/** @format */

import React, { ReactNode } from "react";
import styles from "./circleButtonStyle.module.scss";
import tiaxet from "../../../../assets/images/tiaxet.svg";

type CircleButtonType = {
	onTap: () => void;
	title?: string | null | ReactNode;
	isGrayColor?: boolean;
	customStyle?: React.CSSProperties;
	isShowMana?: boolean;
};
export default function CircleButton({
	onTap,
	title,
	isGrayColor = false,
	customStyle,
	isShowMana,
}: CircleButtonType) {
	return (
		<button
			id="button"
			onClick={onTap}
			style={{
				background: "transparent",
				...customStyle,
			}}
			className="active-btn"
		>
			{
				<div
					className={
						isGrayColor === false ? styles.body : styles.body1
					}
				>
					<span className={styles.childrenStyle}>{title}</span>
					{isShowMana && (
						<img
							src={tiaxet}
							alt="tiaxet"
							width={15}
							style={{ marginLeft: "2px" }}
						/>
					)}
				</div>
			}
		</button>
	);
}
